import { useState, useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CrmUtils from '../../services/crm-utils/CrmUtils';

function CityAutocomplete({ value, onChange, placeholder = "בחרו עיר", required = false, hasError = false }) {
	const [citiesList, setCitiesList] = useState([]);

	useEffect(() => {
		const fetchCities = async () => {
			try {
				const response = await CrmUtils.getCities();
				if (response.data) {
					const seenNames = new Set();
					const formattedCities = response.data
						.map((city, index) => ({
							id: city._id || city.id || `city-${index}`,
							label: city.name || city.label
						}))
						.filter(city => {
							if (seenNames.has(city.label)) {
								return false;
							}
							seenNames.add(city.label);
							return true;
						});
					setCitiesList(formattedCities);
				}
			} catch (error) {
				console.error('Error fetching cities:', error);
			}
		};
		fetchCities();
	}, []);

	return (
		<Autocomplete
			value={value}
			onChange={(_, newValue) => onChange(newValue)}
			options={citiesList}
			getOptionLabel={(option) => option.label || ''}
			isOptionEqualToValue={(option, val) => option.id === val?.id}
			renderInput={(params) => (
				<TextField
					{...params}
					placeholder={placeholder}
					required={required && !value}
					className="city-autocomplete"
				/>
			)}
			componentsProps={{
				paper: {
					sx: {
						fontSize: '14px',
						fontFamily: 'inherit',
						direction: 'rtl',
						'& .MuiAutocomplete-option': {
							fontSize: '14px',
							fontFamily: 'inherit',
							padding: '10px 15px',
						},
					},
				},
			}}
			sx={{
				'& .MuiOutlinedInput-root': {
					padding: '0px !important',
					borderRadius: '4px',
					border: hasError ? '1px solid #FF0000' : 'none',
					'&:hover': {
						borderColor: hasError ? '#FF0000' : '#ccc',
					},
					'&.Mui-focused': {
						borderColor: hasError ? '#FF0000' : '#B50072',
						boxShadow: 'none',
					},
					'& fieldset': {
						border: 'none',
					},
				},
				'& input.MuiInputBase-input': {
					padding: '12px 15px 12px 30px !important',
					fontSize: '14px',
					fontFamily: 'inherit',
					direction: 'rtl',
					textAlign: 'right'
				},
				'& .MuiAutocomplete-endAdornment': {
					right: 'unset',
					left: '15px',
				},
				'& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
					right: 'unset',
					fontFamily: 'AlmoniDL'
				},
				'& button': {
					left: '-4px',
					right: 'unset',
					position: 'absolute',
					top: '-9px',
				},
				'& button.MuiAutocomplete-clearIndicator': {
					left: '15px'
				}
			}}
		/>
	);
}

export default CityAutocomplete;
